/** Where a Settings → History row sends the caller, when they can still open the record. */ const PROGRAM_PATHS = {
    program_documents: 'docs',
    program_modifications: 'docs',
    document: 'docs',
    program_tasks: 'deliverables',
    task: 'deliverables',
    deliverable_instances: 'deliverables',
    deliverable_evidence: 'deliverables',
    risks: 'potential-issues',
    issues: 'potential-issues',
    ContractChangeSet: 'docs?tab=modifications',
    contract_change_sets: 'docs?tab=modifications',
    modification_change_set: 'docs?tab=modifications',
    award_import_change_set: 'docs?tab=modifications',
    ContractChangeItem: 'docs?tab=modifications',
    contract_clins: 'clins',
    contract_clin: 'clins',
    clin: 'clins',
    periods_of_performance: 'periods',
    period: 'periods',
    optional_tasks: 'optional-tasks',
    optional_task_exercises: 'optional-tasks',
    program_capabilities: 'capabilities',
    capability: 'capabilities'
};
export function activityHref(entry) {
    if (entry.recordHidden) return undefined;
    const programId = entry.objectType === 'delivery.programs' || entry.objectType === 'program' ? entry.objectId : entry.programId;
    if (!programId) return undefined;
    const base = `/delivery/programs/${encodeURIComponent(programId)}`;
    const path = PROGRAM_PATHS[entry.objectType];
    if (!path) return base;
    return `${base}/${path}`;
}
export const ACTIVITY_KIND_OPTIONS = [
    {
        value: '',
        label: 'All activity'
    },
    {
        value: 'change_set',
        label: 'Change sets'
    },
    {
        value: 'task',
        label: 'Deliverables'
    },
    {
        value: 'document',
        label: 'Documents'
    },
    {
        value: 'program',
        label: 'Programs'
    },
    {
        value: 'clin',
        label: 'CLINs'
    },
    {
        value: 'period',
        label: 'Periods'
    },
    {
        value: 'risk',
        label: 'Risks'
    },
    {
        value: 'contract_model',
        label: 'Contract model'
    },
    {
        value: 'role',
        label: 'Roles'
    }
];
export function utcDayKey(date) {
    return date.toISOString().slice(0, 10);
}
export function utcDayLabel(day) {
    const [year, month, date] = day.split('-').map(Number);
    return new Date(Date.UTC(year, month - 1, date)).toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC'
    });
}
